import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MediaObserver } from '@angular/flex-layout';
import * as moment from 'moment';

@Component({
  selector: 'app-promo-shedules',
  templateUrl: './promo-shedules.component.html',
  styleUrls: ['./promo-shedules.component.css']
})
export class PromoShedulesComponent implements OnInit {

  pricePeriod: any;
  innerHeight: number = window.innerHeight;

  constructor(
    private dialogRef: MatDialogRef<PromoShedulesComponent>,
    private media: MediaObserver,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    this.pricePeriod = data.pricePeriod;
  }

  ngOnInit() {
    this.filterTimeTable();
    this.sortTimeTable();
  }

  filterTimeTable() {
    let newTimeTable :any= [];
    if (this.pricePeriod.timetables.length > 0) {
      this.pricePeriod.timetables.map((slot:any) => {
        if (slot.timeslots.length > 0) {
          newTimeTable.push(slot);
        }
      })
    }
    this.pricePeriod.timetables = newTimeTable;
  }

  sortTimeTable(): void {
    if (moment.locale() === "fr") {
      if (this.pricePeriod.timetables.length > 0 && this.pricePeriod.timetables[0].day !== 1) {
        this.pricePeriod.timetables.push(this.pricePeriod.timetables.shift())
      }
    }
  }

  getDayByIndex(dayindex: number) {
    const format = this.media.isActive("xs") ? "dd" : "dddd";
    return moment().isoWeekday(dayindex).format(format);
  }

  checkCurrentHour(slot: any) {
    const now = moment().format("HH:MM");
    if (slot.end.startsWith("00")) {
      slot.end = "23:59:59";
    }
    return now >= slot.start && now <= slot.end ? true : false;
  }

  checkCurrentDay(dayindex: number) {
    return dayindex === moment().day() ? true : false;
  }

  closeDial() {
    this.dialogRef.close();
  }

}
